import React from 'react'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { Box, IconButton, Menu, MenuItem } from '@mui/material'
import { useGetLoginPagesQuery } from 'src/api/simulation/simulation'

export default function SelectPageTypeDropdown({ setTemplateChanged, pageType, setPageType }) {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)
  const handleClick = event => {
    setTemplateChanged(true)
    setAnchorEl(event.currentTarget)
  }
  const { data } = useGetLoginPagesQuery()

  const loginPageOptions = data?.map(el => el.page) || []

  return (
    <div>
      <Box
        display={'flex'}
        alignItems={'center'}
        sx={{
          fontSize: 16,
          fontWeight: 400,
          fontFamily: 'Plus Jakarta Sans',
          textTransform: 'capitalize'
        }}
        columnGap={1}
        aria-controls='basic-menu'
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
      >
        {data?.find(el => el.page == pageType).displayName}
        <IconButton onClick={handleClick}>
          <KeyboardArrowDownIcon />
        </IconButton>
      </Box>
      <Menu
        sx={{ height: '400px' }}
        id='basic-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
      >
        {loginPageOptions.map((option, index) => (
          <MenuItem
            key={index}
            onClick={() => {
              setPageType(option)
              setAnchorEl(null)
            }}
          >
            {`${data?.find(el => el.page == option).displayName}`}
          </MenuItem>
        ))}
      </Menu>
    </div>
  )
}
